export default __webpack_public_path__ + "static/media/ic_location.2b6e5daf.svg";